import React, { useEffect, useState } from "react";
import NearbyCard from "./NearbyCard.tsx";
import {
  line,
  near1,
  near2,
  near3,
  near4,
  near5,
  near6,
  near7,
  near8,
} from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const nearby = [
  {
    title: "Wet n Joy",
    image: near1,
    link: "https://www.google.com/maps/search/wet+n+joy/@18.7558274,73.4915343,13.97z?entry=ttu",
  },
  {
    title: "Bhushi Dam",
    image: near2,
    link: "https://www.google.com/maps/place/Bhushi+dam/@18.7227373,73.39168,17z/data=!3m1!4b1!4m6!3m5!1s0x3be8010717b4b8ef:0x9f74dc030691dc4f!8m2!3d18.7227323!4d73.3965509!16s%2Fg%2F11s6vmyy9s?entry=ttu",
  },
  {
    title: "Tiger Point",
    image: near3,
    link: "https://www.google.com/maps/place/Tiger+Point+Lonavala/@18.696092,73.3826601,17z/data=!3m1!4b1!4m6!3m5!1s0x3be803ec63c748df:0xb440dcf326c3e04a!8m2!3d18.6960869!4d73.385235!16s%2Fg%2F11g8yj76ch?entry=ttu",
  },
  {
    title: "Bhaje Waterfall",
    image: near4,
    link: "https://maps.app.goo.gl/krXNAE633J1u2dMM9",
  },
  {
    title: "Ekvira Temple",
    image: near5,
    link: "https://maps.app.goo.gl/Mr8f5TnTw27u4ouh9",
  },
  {
    title: "Kuna Cave",
    image: near6,
    link: "https://maps.app.goo.gl/96rDycoMFpbpff9M9",
  },
  {
    title: "Karla caves",
    image: near7,
    link: "https://www.google.com/maps/place/Karla+Caves/@18.7832813,73.4678677,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2aa834e2141d3:0x7a7b9cf6961b6d76!8m2!3d18.7832762!4d73.4704426!16zL20vMDZ2ZDhk?entry=ttu",
  },
  {
    title: "Visapur Fort",
    image: near8,
    link: "https://maps.app.goo.gl/GktktJvoufevVfHL8",
  },
];

const Nearby = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
        const footerSection2 = gsap.from(".nearBySection", {
          opacity: 0,
          duration: 1,
          x: -500,
          scrollTrigger: {
            trigger: ".nearBySection",
            scroller: "body",
            markers: false,
            start: "top 100%",
          },
        });
        ScrollTrigger.matchMedia({
          "(max-width: 800px)": function () {
            footerSection2.vars.x = 0;
          },
        });
    }
  });
  return (
    <div className="app" style={{ paddingTop: "60px" }}>
      <div
        className="h1_div"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img className="img-size" src={line} alt="" />
        <h1
          style={{
            textAlign: "center",
            fontSize: "40px",
            padding: "26px 0px",
            margin: "0px 20px",
          }}
          className="titlesFontFamily"
        >
          Near By Places
        </h1>
        <img className="img-size" src={line} alt="" />
      </div>
      <div
        className="amenity-list nearBySection"
        style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
      >
        {nearby.map((Near) => (
          <NearbyCard title={Near.title} image={Near.image} link={Near.link} />
        ))}
      </div>
    </div>
  );
};

export default Nearby;
